import { render, staticRenderFns } from "./project_edit_switch.vue?vue&type=template&id=3fbd9d7c&scoped=true"
import script from "./project_edit_switch.vue?vue&type=script&lang=js"
export * from "./project_edit_switch.vue?vue&type=script&lang=js"
import style0 from "./project_edit_switch.vue?vue&type=style&index=0&id=3fbd9d7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd9d7c",
  null
  
)

export default component.exports